import { TFunction } from "i18next";

export const selectPosition = (
  position: string,
  subject: "athlete" | "staff" | "team",
  sport: string | null,
  author: string,
  t: TFunction<"translation", undefined>
): string => {
  // this is a bit convoluted but reads clearly, could be refactored

  const isAthlete = author === "athlete";
  const isStaff = ["medStaff", "techStaff", "management"].includes(author);
  const isTeam = author === "team";

  const lookForAthlete = subject === "athlete";
  const lookForStaff = subject === "staff";
  const lookForTeam = subject === "team";

  const staffPosition = t(`sportData.positions.staff.${position}`);
  const sportPosition = t(`sportData.positions.${sport}.${position}`);

  if (isAthlete && lookForTeam) return sportPosition;
  if (isAthlete && lookForStaff) return staffPosition;
  if (isTeam && lookForAthlete) return sportPosition;

  if (isTeam && lookForStaff) return staffPosition;
  if (isStaff && lookForTeam) return staffPosition;
  return "";
};
